import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BreakdownBarList } from './BreakdownBarList';
import type { PreferenceBreakdownRow } from '../../types/activity-overview';

interface PreferenceBreakdownProps {
  rows: PreferenceBreakdownRow[];
}

/**
 * By Preference — activity-level dimension: primary count is tagged
 * activities; secondary is the total active stages across those activities.
 */
export function PreferenceBreakdown({ rows }: PreferenceBreakdownProps) {
  return (
    <Card className="bg-pine-card border-pine-line shadow-pine-card rounded-pine-card">
      <CardHeader>
        <CardTitle className="text-heading-4 text-pine-ink">By Preference</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-caption text-pine-ink-soft">
          Preferences are activity-level, not stage-level like domains and skills. The secondary
          count is the total active stages across those activities.
        </p>
        <BreakdownBarList
          rows={rows.map((row) => ({
            key: String(row.id),
            label: <span className="truncate">{row.title}</span>,
            primary: row.activityCount,
            secondary: row.stageCount,
            secondaryLabel: 'active stages',
          }))}
        />
      </CardContent>
    </Card>
  );
}
